import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.gmarket-login', {
        url: '/gmarketlogin/:domain?code&error_code',
        component: 'googleMarketplaceConfigurationLogin',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.state.js